import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import MarketingMaterialSampleWatermark from '../../../MarketingMaterialSampleWatermark';

const propTypes = {
  label: PropTypes.string.isRequired,
  previewUrl: PropTypes.string.isRequired,
  isSample: PropTypes.bool,
};

const MarketingMaterialSample = ({ label, previewUrl, isSample }) => {
  return (
    <Fragment>
      <h3 className="text-center">Previewing: {label}</h3>
      <div className="marketing-material-sample">
        <img src={previewUrl} alt="Preview" />

        {isSample && <MarketingMaterialSampleWatermark />}
      </div>
    </Fragment>
  );
};

MarketingMaterialSample.propTypes = propTypes;

export default MarketingMaterialSample;
